import { lazy } from 'react';

export const LazySetPasswordPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--set-password-page" */ './set-password-page'
    ),
);
